import {
  HeadMetatags,
  DefaultPageLayout,
  Container,
} from 'routes/components/Layout'
import { PricingHero } from './components/Hero'
import { PricingPlatformFee } from './components/PlatformFee'
import { PricingFAQ } from './components/FAQ'
import { PricingBestSupport } from './components/BestSupport'
import { PricingRequestADemo } from './components/RequestADemo'
import classes from './Pricing.module.scss'

export const PricingPage = () => {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags title={'Pricing'} />
      <Container grid>
        <PricingHero />
        <PricingPlatformFee />
        <PricingFAQ />
        <PricingBestSupport />
        <PricingRequestADemo />
      </Container>
    </DefaultPageLayout>
  )
}
